import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7857 21.3642C19.5056 21.3642 20.196 21.0781 20.705 20.569C21.214 20.0598 21.5 19.3692 21.5 18.6492V11.2516L15.2761 14.8916L18.4292 16.5894C18.5877 16.6748 18.7058 16.8197 18.7575 16.9923C18.8091 17.1648 18.7902 17.3508 18.7047 17.5093C18.6193 17.6678 18.4744 17.7859 18.302 17.8376C18.1295 17.8893 17.9435 17.8703 17.785 17.7849L12.6433 15.0156C12.4456 14.9091 12.2245 14.8534 12 14.8534C11.7755 14.8534 11.5544 14.9091 11.3567 15.0156L6.21495 17.7849C6.0569 17.8667 5.87305 17.8831 5.703 17.8307C5.53294 17.7782 5.39031 17.661 5.30582 17.5043C5.22134 17.3476 5.20177 17.164 5.25132 16.9931C5.30088 16.8221 5.4156 16.6774 5.57076 16.5903L8.72386 14.8916L2.5 11.2516V18.6492C2.5 19.3692 2.78597 20.0598 3.295 20.569C3.80402 21.0781 4.49441 21.3642 5.21429 21.3642H18.7857Z"
        fill={colorValue}
      />
      <path
        d="M2.5 9.67968V9.00545C2.49993 8.51508 2.63263 8.03386 2.88401 7.61287C3.13539 7.19188 3.49605 6.84685 3.92771 6.61442L10.7134 2.96C11.1089 2.74708 11.5509 2.63562 12 2.63562C12.4491 2.63562 12.8911 2.74708 13.2866 2.96L20.0723 6.61442C20.5039 6.84685 20.8646 7.19188 21.116 7.61287C21.3674 8.03386 21.5001 8.51508 21.5 9.00545V9.67968L13.8765 14.1377L13.2866 13.8201C12.8911 13.6072 12.4491 13.4957 12 13.4957C11.5509 13.4957 11.1089 13.6072 10.7134 13.8201L10.1235 14.1377L2.5 9.67968Z"
        fill={colorValue}
      />
    </svg>
  );
};
